/**
 * centralHeating 模块英文映射
 * 中文原文做 key，value 为英文译文；由 src/i18n/index.js 自动合并
 */
export default {
  'IMSI号': 'IMSI No.',
  'SIM卡号': 'SIM Card No.',
  '上报累计开阀时间(分钟)': 'Reported Cumulative Open Valve Time (min)',
  '不启用': 'Disabled',
  '允许透支时间(分钟)': 'Allowed Overdraft Time (min)',
  '内部温度(℃)': 'Internal Temperature (℃)',
  '启用': 'Enabled',
  '命令标识': 'Command ID',
  '报警剩余时间(分钟)': 'Alarm Remaining Time (min)',
  '接收时间': 'Received At',
  '查询结束时间': 'End time',
  '查询起始时间': 'Start time',
  '状态字信息': 'Status Word Info',
  '用户姓名': 'Customer Name',
  '用户编号': 'Customer No.',
  '磁干扰': 'Magnetic Interference',
  '累计通讯耗时(s)': 'Total Communication Time (s)',
  '缺电关阀时间(分钟)': 'Low-Power Close Valve Time (min)',
  '表类型': 'Meter Type',
  '运营商': 'Carrier',
  '阀门开关指令': 'Valve On/Off Command',
  ',日结数据指示: ': ', daily settlement data format: ',
  ',时间间隔: ': ', time interval: ',
  ',端口号:': ', port:',
  ',结束时间:': ', end time:',
  ',错峰间隔: ': ', off-peak interval: ',
  ',高频上报次数: ': ', high-frequency report count: ',
  '0-255,255表示不启用': '0-255, 255 means disabled',
  '0~255,255表示不启用': '0~255, 255 means disabled',
  'APN参数': 'APN',
  'AT指令校时': 'AT Command Time Sync',
  'CSS': 'CSS',
  'IMEI号': 'IMEI No.',
  'IP地址': 'IP Address',
  'IP地址: ': 'IP address: ',
  'IP输入有误': 'Invalid IP address',
  'LVD': 'LVD',
  'NB加密使能': 'NB Encryption Enabled',
  'NRST': 'NRST',
  'PCA': 'PCA',
  'V,告警阈值2:': 'V, alarm threshold 2:',
  'WDT': 'WDT',
  'lockup': 'lockup',
  'sim卡号': 'SIM Card No.',
  '一级欠压': 'Level-1 Undervoltage',
  '上报使能配置': 'Report Enable Config',
  '上报方式': 'Report Method',
  '上报时间': 'Report Time',
  '上报次数': 'Report Count',
  '上报离散结束估长': 'Report Spread Duration',
  '上报离散结束时间': 'Report Spread End Time',
  '上报离散起始时间': 'Report Spread Start Time',
  '上报频率': 'Report Frequency',
  '上电上报': 'Power-on Report',
  '上电上报使能': 'Power-on Report Enable',
  '上线指令内容设置': 'Online Command Content Settings',
  '下载插件': 'Download Plugin',
  '不使能': 'Disabled',
  '不加密': 'Not Encrypted',
  '不开启': 'Off',
  '不支持': 'Not Supported',
  '不清除故障': 'Do Not Clear Fault',
  '不记录': 'No Record',
  '临时充值卡': 'Temporary Recharge Card',
  '买水次数': 'Water Purchase Count',
  '二级欠压': 'Level-2 Undervoltage',
  '产品型号': 'Product Model',
  '低电压故障': 'Low Voltage Fault',
  '余额报警': 'Balance Alarm',
  '使能': 'Enabled',
  '信号强度(CSQ)': 'Signal Strength (CSQ)',
  '信噪比(SNR)': 'SNR',
  '信息': 'Notice',
  '修改充值次数': 'Modify Recharge Count',
  '修改根秘钥': 'Modify Root Key',
  '修改运行密匙': 'Modify Operating Key',
  '修改运行秘钥': 'Modify Operating Key',
  '允许透支时间': 'Allowed Overdraft Time',
  '元': 'CNY',
  '元/m³': 'CNY/m³',
  '充值': 'Recharge',
  '充值时间': 'Recharge Time',
  '充值时间(分钟)': 'Recharge Time (min)',
  '充值次数': 'Recharge Count',
  '充值次数：': 'Recharge count: ',
  '充值结果': 'Recharge Result',
  '充值量': 'Recharge Volume',
  '充值量：': 'Recharge volume: ',
  '共{total}条': 'Total {total} records',
  '关闭': 'Close',
  '关阀': 'Close Valve',
  '关阀(强制)': 'Close Valve (Forced)',
  '其他': 'Other',
  '内核温度(℃)': 'Core Temperature (℃)',
  '写卡': 'Write Card',
  '写卡器连接错误，请确保插件正常运行后，刷新页面重试!': 'Card writer connection error. Make sure the plugin is running properly, then refresh the page and try again!',
  '写卡失败': 'Card write failed',
  '写卡成功': 'Card written successfully',
  '写卡操作': 'Card Writing',
  '写卡类型': 'Card Write Type',
  '写表号': 'Write Meter No.',
  '出水温度(℃)': 'Outlet Temperature (℃)',
  '出水温度突变阀值': 'Outlet Temperature Sudden-change Threshold',
  '分': 'min',
  '分钟': 'min',
  '创建人': 'Created By',
  '创建时间': 'Created At',
  '删除': 'Delete',
  '到达失联次数关阀': 'Lost-Contact Count Close Valve',
  '到达报警量关阀': 'Alarm Amount Close Valve',
  '刷卡上报使能': 'Card-swipe Report Enable',
  '刷卡开阀': 'Card Swipe Open Valve',
  '刷卡日期：': 'Swipe date: ',
  '刷卡标识：': 'Swipe flag: ',
  '刷新': 'Refresh',
  '刷新当前页面?': 'Refresh this page?',
  '刷新当前页面重置当前页面，请确定是否进行刷新操作?': 'Refreshing will reset this page. Are you sure you want to refresh?',
  '剩余天数报警阀控使能': 'Remaining Days Alarm Valve Control Enable',
  '剩余开阀时间(分钟)': 'Remaining Open Valve Time (min)',
  '剩余金额': 'Remaining Balance',
  '剩余金额更新': 'Remaining Balance Update',
  '功能描述': 'Function Description',
  '加密': 'Encrypted',
  '加密参数': 'Encryption Parameters',
  '升级中': 'Upgrading',
  '升级失败': 'Upgrade Failed',
  '升级成功': 'Upgrade Successful',
  '单价': 'Unit Price',
  '单次购买最大金额': 'Max Single Purchase Amount',
  '卡类型': 'Card Type',
  '即时告警ID': 'Instant Alarm ID',
  '历史日结信息查询': 'Daily Settlement History Query',
  '压力值': 'Pressure',
  '压力报警上限': 'Pressure Alarm Upper Limit',
  '压力报警下限': 'Pressure Alarm Lower Limit',
  '压力报警灵敏度': 'Pressure Alarm Sensitivity',
  '压力数据指示': 'Pressure Data Format',
  '参数卡': 'Parameter Card',
  '发送时间': 'Send Time',
  '发送状态': 'Send Status',
  '取消': 'Cancel',
  '取消升级': 'Upgrade Cancelled',
  '取消强制': 'Cancel Force',
  '取消强制关阀': 'Cancel Forced Close Valve',
  '取消选择': 'Deselect',
  '取消阀控': 'Cancel Valve Control',
  '否': 'No',
  '告警阈值1: ': 'Alarm threshold 1: ',
  '周': 'Week',
  '命令下发': 'Send Command',
  '命令参数': 'Command Parameters',
  '命令回应内容': 'Command Response',
  '命令添加成功': 'Command added successfully',
  '命令类型': 'Command Type',
  '命令结果': 'Command Result',
  '命令队列': 'Command Queue',
  '回应时间': 'Response Time',
  '回水温度校准系数': 'Return Water Temperature Calibration Factor',
  '基本信息': 'Basic Information',
  '基本数据': 'Basic Data',
  '处理失败': 'Processing Failed',
  '处理成功': 'Processed Successfully',
  '备注': 'Remark',
  '天': 'Day',
  '失联次数阈值': 'Lost-Contact Count Threshold',
  '存储器故障': 'Memory Fault',
  '定时上报': 'Scheduled Report',
  '定时上报离散估长(秒)': 'Scheduled Report Spread Duration (s)',
  '定时上报离散结束时间': 'Scheduled Report Spread End Time',
  '定时上报离散起始时间': 'Scheduled Report Spread Start Time',
  '定时上报频率': 'Scheduled Report Frequency',
  '密集流量': 'Intensive Flow',
  '密集采样数据格式': 'Intensive Sampling Data Format',
  '密集采集流量': 'Intensive Sampled Flow',
  '导出': 'Export',
  '导出文件': 'Export File',
  '小区ID(CellID)': 'Cell ID',
  '展开': 'Expand',
  '工作模式': 'Work Mode',
  '已下达': 'Issued',
  '已刷卡': 'Swiped',
  '已取消': 'Cancelled',
  '已选择 {count} 项': '{count} items selected',
  '干扰不关阀': 'No Valve Close on Interference',
  '干扰关阀': 'Interference Close Valve',
  '干扰关阀时间': 'Interference Close Valve Time',
  '干扰持续时间': 'Interference Duration',
  '干扰是否关阀': 'Close Valve on Interference',
  '平台计费水表': 'Platform-billed Water Meter',
  '年': 'Year',
  '开关阀': 'Open/Close Valve',
  '开关阀故障': 'Open/Close Valve Fault',
  '开启': 'On',
  '开始时间': 'Start Time',
  '开阀': 'Open Valve',
  '开阀(强制)': 'Open Valve (Forced)',
  '强制关阀': 'Force Close Valve',
  '强制开阀': 'Force Open Valve',
  '强制状态': 'Forced Status',
  '强制阀控状态': 'Forced Valve Control Status',
  '当前剩余开阀时间(分钟)': 'Current Remaining Open Valve Time (min)',
  '当前累计开阀时间(分钟)': 'Current Cumulative Open Valve Time (min)',
  '当前选择：': 'Currently selected:',
  '待升级': 'Pending Upgrade',
  '手动上报': 'Manual Report',
  '执行失败': 'Execution Failed',
  '执行成功': 'Executed Successfully',
  '批量操作': 'Batch Operations',
  '折叠': 'Collapse',
  '报警剩余时间': 'Alarm Remaining Time',
  '报警参数配置': 'Alarm Parameter Config',
  '报警时间': 'Alarm Time',
  '报警金额': 'Alarm Amount',
  '持续反流告警时间': 'Reverse Flow Alarm Duration',
  '持续过流告警时间': 'Overcurrent Alarm Duration',
  '按季度': 'Quarterly',
  '按年': 'Yearly',
  '按月': 'Monthly',
  '换表卡': 'Meter Replacement Card',
  '接收信号功率(RSRP)': 'RSRP',
  '接收回应时间': 'Response Received At',
  '描述': 'Description',
  '提示': 'Notice',
  '插件连接成功': 'Plugin connected',
  '操作': 'Action',
  '收起': 'Collapse',
  '故障': 'Fault',
  '故障上报': 'Fault Report',
  '故障产生时间': 'Fault Occurrence Time',
  '故障参数配置': 'Fault Parameter Config',
  '故障持续时间': 'Fault Duration',
  '故障清除': 'Clear Fault',
  '故障清除位': 'Fault Clear Flag',
  '故障清除卡': 'Fault Clear Card',
  '故障类型': 'Fault Type',
  '数据': 'Data',
  '数据清除': 'Data Clear',
  '数据详情': 'Data Details',
  '新增': 'Add',
  '新表编号': 'New Meter No.',
  '无': 'None',
  '无到位信号': 'No In-place Signal',
  '无动作': 'No Action',
  '无数据': 'No Data',
  '无记录': 'No Record',
  '无阀': 'No Valve',
  '日': 'Day',
  '日结数据指示': 'Daily Settlement Data Format',
  '日结数据组数': 'Daily Settlement Data Groups',
  '日结数据组数: ': 'Daily settlement data groups: ',
  '日结累计流量': 'Daily Settlement Total Flow',
  '日结累计流量(m³)': 'Daily Settlement Total Flow (m³)',
  '时': 'h',
  '时间': 'Time',
  '是': 'Yes',
  '是否启用计费窗口1': 'Enable Billing Window 1',
  '是否启用计费窗口2': 'Enable Billing Window 2',
  '是否启用间隔流量采集': 'Enable Interval Flow Sampling',
  '暖通阀': 'HVAC Valve',
  '更多': 'More',
  '最大囤积金额': 'Max Stockpile Amount',
  '最大失联次数阈值': 'Max Lost-Contact Count Threshold',
  '最大激活上报次数': 'Max Activation Report Count',
  '最大补包次数': 'Max Packet Retransmission Count',
  '最大透支金额': 'Max Overdraft Amount',
  '月': 'Month',
  '有': 'Yes',
  '有关阀故障': 'Close Valve Fault',
  '有开阀故障': 'Open Valve Fault',
  '有故障': 'Faulty',
  '有无磁干扰': 'Magnetic Interference',
  '未刷卡': 'Not Swiped',
  '未发送': 'Not Sent',
  '未知': 'Unknown',
  '本次通讯耗时(s)': 'Communication Time (s)',
  '机电分离故障': 'Mechanical-Electrical Separation Fault',
  '查询': 'Query',
  '查询基础信息': 'Query Basic Info',
  '查询实时数据': 'Query Real-time Data',
  '查询终端参数': 'Query Terminal Parameters',
  '标准卡': 'Standard Card',
  '校时': 'Time Sync',
  '校时卡': 'Time Sync Card',
  '校时方式': 'Time Sync Mode',
  '根秘钥': 'Root Key',
  '模块初始化配置': 'Module Initialization Config',
  '模组号': 'Module No.',
  '模组版本号': 'Module Version',
  '欠压': 'Undervoltage',
  '次': 'times',
  '正在下发': 'Dispatching',
  '正常': 'Normal',
  '水编号卡': 'Water No. Card',
  '水表校对卡': 'Meter Verification Card',
  '水表编号卡': 'Water Meter No. Card',
  '水表表号': 'Water Meter No.',
  '流量(m³)': 'Flow (m³)',
  '测温周期': 'Temperature Measurement Cycle',
  '测试卡': 'Test Card',
  '消息有误': 'Invalid Message',
  '清空': 'Clear',
  '清除表端故障': 'Clear Meter Faults',
  '清零卡': 'Reset Card',
  '温度值': 'Temperature',
  '温度报警上限': 'Temperature Alarm Upper Limit',
  '温度报警下限': 'Temperature Alarm Lower Limit',
  '温度报警灵敏度': 'Temperature Alarm Sensitivity',
  '温度数据指示': 'Temperature Data Format',
  '激活上报次数': 'Activation Report Count',
  '状态': 'Status',
  '用户余额': 'Customer Balance',
  '用户卡': 'User Card',
  '用户卡号': 'User Card No.',
  '用户卡号：': 'User card no.: ',
  '用户地址': 'Customer Address',
  '用户姓名模糊查询': 'Search by customer name',
  '用户手机号': 'Customer Mobile Phone',
  '用户模式': 'User Mode',
  '用户编号模糊查询': 'Search by customer no.',
  '电信AEP': 'China Telecom AEP',
  '电信OC': 'China Telecom OC',
  '电压告警阈值1': 'Voltage Alarm Threshold 1',
  '电压告警阈值1(V)': 'Voltage Alarm Threshold 1 (V)',
  '电压告警阈值2': 'Voltage Alarm Threshold 2',
  '电压告警阈值2(V)': 'Voltage Alarm Threshold 2 (V)',
  '电池状态': 'Battery Status',
  '电池电压(V)': 'Battery Voltage (V)',
  '电池电压(mv)': 'Battery Voltage (mV)',
  '直通用水': 'Direct Water Use',
  '确定': 'OK',
  '确定删除吗?': 'Are you sure you want to delete?',
  '磁干扰故障': 'Magnetic Interference Fault',
  '秒': 's',
  '秘钥': 'Key',
  '移动': 'China Mobile',
  '程序序列号': 'Program Serial No.',
  '端口号': 'Port',
  '端口号输入有误': 'Invalid port number',
  '第一阶段用水价格': 'Tier-1 Water Price',
  '累积开阀时间(分钟)': 'Cumulative Open Valve Time (min)',
  '累积量': 'Cumulative Volume',
  '累计发送失败次数': 'Total Failed Sends',
  '累计发送成功次数': 'Total Successful Sends',
  '累计开阀时长：': 'Cumulative open valve duration: ',
  '累计用量超限关阀': 'Cumulative Usage Limit Close Valve',
  '红外加密使能': 'Infrared Encryption Enabled',
  '终端协议版本号': 'Terminal Protocol Version',
  '终端参数ID': 'Terminal Parameter ID',
  '终端参数设置': 'Terminal Parameter Settings',
  '终端故障记录': 'Terminal Fault Records',
  '终端时钟': 'Terminal Clock',
  '终端软件版本': 'Terminal Software Version',
  '终端运行时间': 'Terminal Running Time',
  '编辑': 'Edit',
  '缺电不关阀': 'No Valve Close on Low Power',
  '缺电关阀': 'Low Power Close Valve',
  '缺电关阀时间': 'Low-Power Close Valve Time',
  '缺电是否关阀': 'Close Valve on Low Power',
  '联网失败原因': 'Network Failure Reason',
  '联网失败时间': 'Network Failure Time',
  '联网失败记录': 'Network Failure Records',
  '联通': 'China Unicom',
  '脉冲系数': 'Pulse Factor',
  '自动关阀/阀门自检': 'Auto Close Valve / Valve Self-check',
  '自动开阀/ 阀门自检': 'Auto Open Valve / Valve Self-check',
  '自动校时': 'Automatic Time Sync',
  '自定义列': 'Custom Columns',
  '自定义校时': 'Custom Time Sync',
  '表具实时数据': 'Meter Real-time Data',
  '表口径': 'Meter Caliber',
  '表号': 'Meter No.',
  '表底数': 'Meter Base',
  '表端不计费': 'No Meter-side Billing',
  '表端信号状态': 'Meter Signal Status',
  '表端实时数据': 'Meter Real-time Data',
  '表端时间': 'Meter Time',
  '表端状态11信息': 'Meter Status Info',
  '表端状态信息': 'Meter Status Info',
  '表端自检功能': 'Meter Self-Check',
  '表端计费': 'Meter-side Billing',
  '表端计费水量表': 'Meter-billed Volume Meter',
  '表端计费金额表': 'Meter-billed Amount Meter',
  '表类型切换': 'Meter Type Switch',
  '表编号': 'Meter No.',
  '表编号模糊查询': 'Search by meter no.',
  '覆盖等级(ECL)': 'Coverage Level (ECL)',
  '计费开始时间': 'Billing Start Time',
  '计费窗口': 'Billing Window',
  '计费窗口1结束时间': 'Billing Window 1 End Time',
  '计费窗口1起始时间': 'Billing Window 1 Start Time',
  '计费窗口2结束时间': 'Billing Window 2 End Time',
  '计费窗口2起始时间': 'Billing Window 2 Start Time',
  '计费窗口参数设置': 'Billing Window Parameter Settings',
  '计费类型': 'Billing Type',
  '计费结束关阀使能': 'Billing End Close Valve Enable',
  '计费结束时间': 'Billing End Time',
  '计费结束时间：': 'Billing end time: ',
  '计费起始时间：': 'Billing start time: ',
  '记录值': 'Record Value',
  '记录条数': 'Record Count',
  '设置上报参数': 'Set Report Parameters',
  '设置服务器地址': 'Set Server Address',
  '设置电压告警阈值': 'Set Voltage Alarm Threshold',
  '试用模式': 'Trial Mode',
  '试用量': 'Trial Quantity',
  '详情': 'Details',
  '请先选择命令': 'Please select a command first',
  '请表类型': 'Select meter type',
  '请设置url.list属性!': 'Please set the url.list property!',
  '请输入充值次数': 'Enter recharge count',
  '请输入充值量': 'Enter recharge volume',
  '请输入区域名称': 'Please enter area name',
  '请输入单次购买最大金额': 'Enter max single purchase amount',
  '请输入命令参数': 'Enter command parameters',
  '请输入报警时间': 'Enter alarm time',
  '请输入报警金额': 'Enter alarm amount',
  '请输入日期': 'Enter date',
  '请输入最大囤积金额': 'Enter max stockpile amount',
  '请输入最大透支金额': 'Enter max overdraft amount',
  '请输入有无磁干扰': 'Select magnetic interference',
  '请输入查询条数!': 'Please enter the record count!',
  '请输入正确的充值时间!': 'Enter a valid recharge time!',
  '请输入正确的充值次数!': 'Enter a valid recharge count!',
  '请输入正确的充值量': 'Enter a valid recharge volume',
  '请输入正确的根秘钥!': 'Please enter a valid root key!',
  '请输入正确的用户卡号': 'Enter a valid user card no.',
  '请输入正确的计费开始时间': 'Enter a valid billing start time',
  '请输入正确的购买次数': 'Enter a valid purchase count',
  '请输入正确的运行秘钥!': 'Please enter a valid operating key!',
  '请输入用户卡号': 'Enter user card no.',
  '请输入电池状态': 'Select battery status',
  '请输入第一阶段用水价格': 'Enter tier-1 water price',
  '请输入表底数': 'Enter meter base',
  '请输入起始条数!': 'Please enter the start record No.!',
  '请输入透支时间': 'Enter overdraft time',
  '请输入预存金额': 'Enter prepaid amount',
  '请选择': 'Please select',
  '请选择上报方式': 'Please select report method',
  '请选择日期!': 'Please select the date!',
  '请选择表口径': 'Please select meter caliber',
  '请选择阀门是否故障': 'Please select valve fault',
  '请选择阀门状态': 'Select valve status',
  '请重新去水表刷卡': 'Please swipe the card on the water meter again',
  '读SIM卡ismi号': 'Read SIM IMSI No.',
  '读卡': 'Read Card',
  '读卡上报': 'Card Read Report',
  '读卡操作': 'Card Reading',
  '读取SIM卡号': 'Read SIM Card No.',
  '读取参数': 'Read Parameters',
  '读取最近10次联网失败原因': 'Read Last 10 Network Failure Reasons',
  '读取最近10次表端故障原因': 'Read Last 10 Meter Fault Reasons',
  '读取最近10次阀门动作原因': 'Read Last 10 Valve Action Reasons',
  '读取模组IMEI号': 'Read Module IMEI',
  '读取模组版本号': 'Read Module Version',
  '读取模组状态': 'Read Module Status',
  '读取程序版本信息': 'Read Program Version Info',
  '读取表上报参数': 'Read Meter Report Parameters',
  '读取表具信息': 'Read Meter Info',
  '读取表历史数据': 'Read Meter History Data',
  '读取表工作参数': 'Read Meter Working Parameters',
  '读取表端最近10次磁干扰故障': 'Read Last 10 Magnetic Interference Faults',
  '读取表网络参数': 'Read Meter Network Parameters',
  '读表号': 'Read Meter No.',
  '调试模式': 'Debug Mode',
  '购买次数：': 'Purchase count: ',
  '起始时间: ': 'Start time: ',
  '起始条数': 'Start Record No.',
  '超声波水表': 'Ultrasonic Water Meter',
  '超级阀门卡': 'Super Valve Card',
  '过期未执行': 'Expired, Not Executed',
  '过流告警': 'Overcurrent Alarm',
  '过流告警关阀': 'Overcurrent Alarm Close Valve',
  '运营平台校时': 'Platform Time Sync',
  '运行秘钥': 'Operating Key',
  '进水温度(℃)': 'Inlet Temperature (℃)',
  '进水温度校准系数': 'Inlet Temperature Calibration Factor',
  '进水温度突变阀值': 'Inlet Temperature Sudden-change Threshold',
  '远程关阀、阀门卡关阀': 'Remote/Card Close Valve',
  '远程开阀、阀门卡开阀': 'Remote/Card Open Valve',
  '远程强制关阀': 'Remote Forced Close Valve',
  '退水卡': 'Water Refund Card',
  '逆流告警': 'Reverse Flow Alarm',
  '选择命令': 'Select Command',
  '透支关阀': 'Overdraft Close Valve',
  '透支关阀报警': 'Overdraft Close Valve Alarm',
  '透支时间': 'Overdraft Time',
  '配置表上报参数': 'Configure Meter Report Parameters',
  '配置表工作参数': 'Configure Meter Working Parameters',
  '配置表网络参数': 'Configure Meter Network Parameters',
  '采样始起始时间': 'Sampling Start Time',
  '采样时长': 'Sampling Duration',
  '采样组数': 'Sampling Groups',
  '采样间隔': 'Sampling Interval',
  '采样间隔正流量和逆流量': 'Sampling Interval Forward and Reverse Flow',
  '重传次数': 'Retransmission Count',
  '重传间隔': 'Retransmission Interval',
  '重传间隔(秒)': 'Retransmission Interval (s)',
  '重置': 'Reset',
  '间隔流量': 'Interval Flow',
  '间隔流量数据指示': 'Interval Flow Data Format',
  '间隔流量采集间隔': 'Interval Flow Sampling Interval',
  '间隔累计正流量和间隔累计逆流量': 'Interval Cumulative Forward and Reverse Flow',
  '间隔累计流量': 'Interval Cumulative Flow',
  '阀控使能配置': 'Valve Control Enable Config',
  '阀控操作': 'Valve Control Operation',
  '阀门关故障': 'Valve Close Fault',
  '阀门到位超时时间': 'Valve Position Timeout',
  '阀门到位超时时间(秒)': 'Valve Position Timeout (s)',
  '阀门动作上报': 'Valve Action Report',
  '阀门动作原因': 'Valve Action Reason',
  '阀门动作时间': 'Valve Action Time',
  '阀门动作状态': 'Valve Action Status',
  '阀门动作记录查询': 'Valve Action Record Query',
  '阀门卡': 'Valve Card',
  '阀门参数配置': 'Valve Parameter Config',
  '阀门堵转使能': 'Valve Stall Enable',
  '阀门堵转是否开启': 'Valve Stall Enabled',
  '阀门开度': 'Valve Opening',
  '阀门开故障': 'Valve Open Fault',
  '阀门操控指令': 'Valve Control Command',
  '阀门是否故障': 'Valve Fault',
  '阀门是否有故障': 'Valve Fault',
  '阀门状态': 'Valve Status',
  '阀门维护': 'Valve Maintenance',
  '阀门锈死故障': 'Rusted Valve Fault',
  '非强制状态': 'Not Forced',
  '预存金额': 'Prepaid Amount',
  '高瞬时流量': 'High Instantaneous Flow',
  '高频上报': 'High-frequency Report',
  '高频上报周期: ': 'High-frequency Report Interval: ',
  '间隔流量时间间隔': 'Interval Flow Time Interval',
}
